
// eslint-disable-next-line valid-jsdoc
/**
 * Fix issue at safari 13.1 regarding getting media
 *
 * @param {<Array.<IDevice>>} mediaInfo list of media from the user device
 * @return {<Array.<IDevice>>} mediaInfo with videoinput if needed
 */
export default function fixMediaInfoAtSafari131(mediaInfo) {
    const isVideoInputFound = mediaInfo.some(d => (d.kind === 'videoinput'));
    const { userAgent } = navigator;
    const isAppleDevice = userAgent.toLowerCase().includes('mac os x');
    const isSafariBased = userAgent.toLowerCase().includes('safari');
    const isVersion131 = userAgent.toLowerCase().includes('version/13.1');


    if (!isVideoInputFound
        && mediaInfo.length >= 2
        && isAppleDevice
        && isSafariBased
        && isVersion131
    ) {
        const firstMediaInfo = {};
        firstMediaInfo.kind = 'videoinput';
        const newMediaInfo = [...mediaInfo];
        newMediaInfo[0] = firstMediaInfo;

        return newMediaInfo;
    }

    return mediaInfo;
}
